import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import './App.css';
import Home from "./pages/Home";
import Header from './pages/Header';
import Menu from './pages/Menu';
import About from './pages/About';
import Images from "./pages/Images";
import Makingvideos from "./pages/Makingvideos";
import Testimonials from './pages/Testmonial';
import ContactUs from './pages/Contactus';
import Footer from './pages/Footer';
import Location from './pages/Location';
import ProductList from './pages/Productlist';
import CakebyCategory from './pages/CakebyCategory';
import Cakes from './pages/Cakes'
import ScrollToTop from './pages/ScrollToTop'; // ✅ Import here

function App() {
  return (
    <Router>
      <ScrollToTop /> {/* ✅ Add this before Routes */}
      <div className="App">
        <Header />

        <Routes>
          <Route path="/" element={
            <>
              <Home />
              <About />
             
              <CakebyCategory/>
               <Images />
              {/* <Makingvideos /> */}
              <Testimonials />
            </>
          } />
          <Route path="/about" element={<About />} />
          <Route path="/cakes" element={<Cakes />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/productlist/:id" element={<ProductList />} />
        </Routes>

        <Location />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
